/* Dillon Welding theme – vanilla JS, no dependencies. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const theme = window.theme || { routes: {}, strings: {} };

  /* ---------- Drawers & modals ---------- */
  let lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('button, a[href], input', drawer.querySelector('.drawer__panel'));
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.drawerOpen));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer(closer.closest('.drawer'));
      return;
    }
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && theme.cartType === 'drawer' && $('#CartDrawer')) {
      e.preventDefault();
      openDrawer($('#CartDrawer'));
      return;
    }
    if (e.target.closest('[data-search-open]')) {
      const modal = $('#SearchModal');
      modal.classList.add('is-open');
      setTimeout(() => $('input[type="search"]', modal).focus(), 30);
      return;
    }
    if (e.target.closest('[data-search-close]') || e.target.id === 'SearchModal') {
      $('#SearchModal').classList.remove('is-open');
    }
    const recover = e.target.closest('[data-recover-toggle]');
    if (recover) {
      e.preventDefault();
      const panel = $('[data-recover]');
      if (panel) panel.hidden = !panel.hidden;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    const modal = $('#SearchModal');
    if (modal) modal.classList.remove('is-open');
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    const wrap = btn.closest('.qty');
    const input = $('[data-qty-input]', wrap);
    const min = Number(input.min || 0);
    const max = Number(input.max || 999);
    const step = btn.hasAttribute('data-qty-plus') ? 1 : -1;
    const next = Math.min(max, Math.max(min, Number(input.value || 0) + step));
    if (next === Number(input.value)) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Section rendering helpers ---------- */
  const sectionIdOf = (el) => (el ? el.id.replace('shopify-section-', '') : null);

  function cartSectionIds() {
    const ids = [];
    const header = $('.header-section');
    if (header) ids.push(sectionIdOf(header));
    if ($('#CartDrawer')) ids.push('cart-drawer');
    const page = $('[data-cart-page]');
    if (page) ids.push(page.dataset.sectionId);
    return ids;
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function renderCartSections(sections) {
    if (!sections) return;
    const headerEl = $('.header-section');
    const headerId = sectionIdOf(headerEl);
    if (headerId && sections[headerId]) {
      const doc = parse(sections[headerId]);
      ['#HeaderCartButton', '.site-header__cart-icon'].forEach((sel) => {
        const fresh = $(sel, doc);
        const current = $(sel, headerEl);
        if (fresh && current) current.replaceWith(fresh);
      });
    }
    if (sections['cart-drawer']) {
      const fresh = $('.drawer__panel', parse(sections['cart-drawer']));
      const current = $('#CartDrawer .drawer__panel');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    const page = $('[data-cart-page]');
    if (page && sections[page.dataset.sectionId]) {
      const fresh = $('[data-cart-page]', parse(sections[page.dataset.sectionId]));
      if (fresh) page.innerHTML = fresh.innerHTML;
    }
  }

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || theme.cartType !== 'drawer' || !$('#CartDrawer')) return;
    e.preventDefault();

    const errorEl = $('[data-form-error]', form);
    const buttons = [$('[data-atc]', form), ...$$(`[form="${form.id}"]`)].filter(Boolean);
    buttons.forEach((b) => b.setAttribute('aria-busy', 'true'));
    if (errorEl) errorEl.hidden = true;

    const body = new FormData(form);
    body.append('sections', cartSectionIds().join(','));
    body.append('sections_url', window.location.pathname);

    try {
      const res = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.cartError);
      renderCartSections(data.sections);
      openDrawer($('#CartDrawer'));
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
    } finally {
      buttons.forEach((b) => b.removeAttribute('aria-busy'));
    }
  });

  /* ---------- Cart line updates ---------- */
  async function changeLine(line, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-loading');
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line,
          quantity,
          sections: cartSectionIds(),
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || theme.strings.cartError);
      renderCartSections(data.sections);
    } catch (err) {
      if (lineEl) lineEl.classList.remove('is-loading');
      window.alert(err.message);
    }
  }

  document.addEventListener('change', (e) => {
    const qtyWrap = e.target.closest('[data-line-qty]');
    if (qtyWrap) {
      changeLine(Number(qtyWrap.dataset.lineQty), Number(e.target.value), e.target.closest('.cart-line'));
    }
  });

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-line-remove]');
    if (remove) changeLine(Number(remove.dataset.lineRemove), 0, remove.closest('.cart-line'));
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    const sectionId = section.dataset.sectionId;
    const form = $('[data-product-form]', section);
    const gallery = $('[data-gallery]', section);
    const slides = gallery ? $$('.gallery__slide', gallery) : [];
    const thumbs = gallery ? $$('[data-gallery-thumb]', gallery) : [];
    const dots = gallery ? $$('.gallery__dots span', gallery) : [];
    let current = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));

    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === current));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      $$('video', gallery).forEach((v) => v.pause());
    }

    if (gallery) {
      gallery.addEventListener('click', (e) => {
        if (e.target.closest('[data-gallery-prev]')) show(current - 1);
        if (e.target.closest('[data-gallery-next]')) show(current + 1);
        const thumb = e.target.closest('[data-gallery-thumb]');
        if (thumb) show(Number(thumb.dataset.galleryThumb));
      });
      let startX = null;
      const main = $('.gallery__main', gallery);
      main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        startX = null;
      });
    }

    /* Variant picker */
    const picker = $('[data-variant-picker]', section);
    if (picker && form) {
      const variants = JSON.parse($('[data-variants]', picker).textContent);
      picker.addEventListener('change', async () => {
        const selected = $$('fieldset', picker).map((fs) => {
          const checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
        selected.forEach((value, i) => {
          const label = $(`[data-option-selected="${i}"]`, picker);
          if (label) label.textContent = value;
        });
        const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        const atc = $('[data-atc]', form);
        if (!variant) {
          if (atc) {
            atc.disabled = true;
            $('span', atc).textContent = theme.strings.unavailable;
          }
          return;
        }
        $('[data-variant-id]', form).value = variant.id;
        const url = `${section.dataset.url}?variant=${variant.id}`;
        window.history.replaceState({}, '', url);

        if (variant.featured_media) {
          const idx = slides.findIndex((s) => Number(s.dataset.mediaId) === variant.featured_media.id);
          if (idx > -1) show(idx);
        }

        try {
          const res = await fetch(`${url}&section_id=${sectionId}`);
          const doc = parse(await res.text());
          ['[data-price-wrap]', '[data-atc-wrap]'].forEach((sel) => {
            const fresh = $(sel, doc);
            const cur = $(sel, section);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
          const sticky = $('[data-atc-sticky]', section);
          if (sticky) sticky.disabled = !variant.available;
        } catch (err) {
          /* Price refresh is best-effort; the form still posts the right variant id. */
        }
      });
    }

    /* Sticky mobile add-to-cart */
    const sticky = $('[data-sticky-atc]', section);
    const mainAtc = $('[data-atc-wrap]', section);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        /* Show whenever the main ATC is off-screen (above OR below) so mobile visitors
           see price + ATC while still looking at the gallery / title. */
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      }).observe(mainAtc);
    }

    /* Keep the sticky bar quantity in sync with the form quantity */
    const mainQty = form ? $('[data-qty-input]', form) : null;
    const mirrorQty = $('[data-qty-mirror] [data-qty-input]', section);
    if (mainQty && mirrorQty) {
      mirrorQty.addEventListener('change', () => { mainQty.value = mirrorQty.value; });
      mainQty.addEventListener('change', () => { mirrorQty.value = mainQty.value; });
    }
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    const buttons = $$('[role="tab"]', root);
    const activate = (btn) => {
      buttons.forEach((b) => {
        const on = b === btn;
        b.setAttribute('aria-selected', on);
        b.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    buttons.forEach((btn, i) => {
      btn.addEventListener('click', () => activate(btn));
      btn.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = buttons[(i + (e.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length];
        activate(next);
        next.focus();
      });
    });
  }

  /* ---------- Workshop films: load YouTube only on click ---------- */
  const THUMB_STEPS = ['maxresdefault', 'sddefault', 'hqdefault'];
  window.ytThumbFallback = (img, failed) => {
    if (!failed && img.naturalWidth > 200) return;
    const step = Number(img.dataset.step || 0) + 1;
    if (step >= THUMB_STEPS.length) return;
    img.dataset.step = step;
    img.src = `https://i.ytimg.com/vi/${img.dataset.ytThumb}/${THUMB_STEPS[step]}.jpg`;
  };
  // Thumbnails that finished loading before this script ran.
  $$('img[data-yt-thumb]').forEach((img) => { if (img.complete) window.ytThumbFallback(img); });

  function stopVideos(root) {
    $$('.video-frame__iframe', root).forEach((frame) => {
      frame.previousElementSibling.hidden = false;
      frame.remove();
    });
  }

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-video-proof] [role="tab"]');
    if (tab) stopVideos(tab.closest('[data-video-proof]'));

    const poster = e.target.closest('[data-youtube]');
    if (!poster) return;
    const frame = document.createElement('iframe');
    frame.className = 'video-frame__iframe';
    frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(poster.dataset.youtube)}?autoplay=1&rel=0&playsinline=1`;
    frame.title = poster.getAttribute('aria-label');
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    poster.hidden = true;
    poster.after(frame);
    frame.focus();
  });

  /* ---------- Product recommendations ---------- */
  async function initRecommendations(el) {
    if (el.children.length) return;
    try {
      const res = await fetch(el.dataset.url);
      const fresh = $('[data-recommendations]', parse(await res.text()));
      if (fresh) el.innerHTML = fresh.innerHTML;
    } catch (err) {
      /* Recommendations are optional. */
    }
  }

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-sort-select]')) e.target.form.submit();
  });

  /* ---------- Init (and re-init inside the theme editor) ---------- */
  function init(root = document) {
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-tabs]', root).forEach(initTabs);
    $$('[data-recommendations]', root).forEach(initRecommendations);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));

  /* Language dropdown: close when clicking outside */
  document.addEventListener('click', (e) => {
    document.querySelectorAll('details.site-header__lang-dd[open]').forEach((dd) => {
      if (!dd.contains(e.target)) dd.removeAttribute('open');
    });
  });

})();
